import { AnimateViewProps } from "./types"

export const sharedProps = new Map<string, AnimateViewProps>()
